import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';
import { SingleAnswer, SingleAnswerProps } from './SingleAnswer';

interface YNNAnswerProps extends SingleAnswerProps {}

const Main = styled(SingleAnswer)`
  &.ynn-answer .question-no-wrapper .question-no {
    .question-text.question-no > span {
      font-weight: 600;
    }
  }
`;

export const YNNAnswer = observer((props: YNNAnswerProps) => {
  return <Main className="dol-question ynn-answer" {...props} />;
});
